<!-- top-menu start -->
<nav class="navbar" id="">
  <div class="container-fluid">
    
    <a class="navbar-brand" title="{{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/']">
      <img class="img-fluid" [defaultImage]="'./assets/images/placeholder.jpg'" [lazyLoad]="(data | async)?.restaurant_data?.logo" 
      alt="{{(data | async)?.restaurant_data?.logo_alt_text ? (data | async)?.restaurant_data?.logo_alt_text : (data | async)?.restaurant_data?.restaurant_name}}" />
    </a>

    <span class="toggle-btn {{toggleActive ? 'toggle-active' : ''}}" (click)="toggleClick()">
      <i class="flaticon-left-alignment" ></i>
    </span>
  </div>
</nav>
<!-- top-menu end -->


<div class="top-menu-bar {{toggleActive ? 'toggle-active' : ''}}">
  <ul class="">
    <li class="nav-item" style="cursor: pointer;" (click)="toggleClick()">
      <a class="nav-link" title="Home" (click)="navigateUrl()" [routerLink]="['/']"routerLinkActive="active">Home</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.about_page?.is_active">
      <a class="nav-link" title="About" [routerLink]="['/about-us']" routerLinkActive="active">About</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_data?.gift_voucher && (data | async)?.restaurant_content?.gift_voucher_page?.is_active">
      <a class="nav-link" title="Gift voucher" [routerLink]="['/gift-voucher']" routerLinkActive="active">Gift Voucher</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.team_page?.is_active">
      <a class="nav-link" title="Team" [routerLink]="['/our-team']" routerLinkActive="active">Team</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
      <a class="nav-link" title="Deals" [routerLink]="['/deals']" routerLinkActive="active">Deals</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.xmas_page?.is_active">
      <a class="nav-link" title="Christmas - {{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/christmas']" routerLinkActive="active">Christmas</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.menu_page?.is_active">
      <a class="nav-link" title="Menu" [routerLink]="['/menu']" routerLinkActive="active">Menu</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.booking_page?.is_active">
      <a class="nav-link" title="Reservation" [routerLink]="['/reservation']" routerLinkActive="active">Reservation</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.review_page?.is_active">
      <a class="nav-link" title="Reviews" [routerLink]="['/reviews']" routerLinkActive="active">Reviews</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.gallery_page?.is_active">
      <a class="nav-link" title="Gallery" [routerLink]="['/gallery']" routerLinkActive="active">Gallery</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.awards_page?.is_active">
      <a class="nav-link" title="Awards" [routerLink]="['/awards']" routerLinkActive="active">Awards</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.event_page?.is_active">
      <a class="nav-link" title="Events" [routerLink]="['/events']" routerLinkActive="active">Events</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.blog_page?.is_active">
      <a class="nav-link" title="Blogs" [routerLink]="['/blogs']" routerLinkActive="active">Blog</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.news_media_page?.is_active">
      <a class="nav-link" title="News & Media - {{(data | async)?.restaurant_data?.restaurant_name}}" [routerLink]="['/news-media']" routerLinkActive="active">News & Media</a>
    </li>
    <li class="nav-item" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.contact_page?.is_active">
      <a class="nav-link" title="Contact" [routerLink]="['/contact-us']" routerLinkActive="active">Contact</a>
    </li>
    <li class="nav-item" (click)="signOut()" *ngIf="(user | async)?.isLogged === true">
      <a class="nav-link" title="Log out" [routerLink]="">Log out</a>
    </li>
    <li class="btn-wrappers">
      <a class="btn btn-light" (click)="toggleClick()" *ngIf="(data | async)?.restaurant_content?.order_online_page?.is_active" 
      [title]="'Order food online from ' + (data | async)?.restaurant_data?.restaurant_name" [routerLink]="['/order-online']" routerLinkActive="active">Order Online</a>
      <a class="btn btn-light" (click)="toggleClick()" *ngIf="(user | async)?.isLogged === false" 
      [routerLink]="['/sign-in']" title="Sign in" routerLinkActive="active">Sign In</a>
      <a class="btn btn-light" (click)="toggleClick()" *ngIf="(user | async)?.isLogged === true" 
      [routerLink]="['/my-account']" title="My account" routerLinkActive="active">My Account</a>
    </li>
  </ul>
  <!-- <ul class="navbar-nav d-block d-lg-none info-menu">
    <li class="nav-item">
      <span class="icon start"><i class="flaticon-phone" ></i></span>
      <p class="contacts">
        <ng-container *ngFor="let item of (data | async)?.restaurant_data?.business_tel | split; index as i;">
          <a class="nav-link py-0" href="tel:{{item.trim()}}">{{item.trim()}}</a>
        </ng-container>
      </p>
    </li>
    <li class="nav-item" *ngIf="(data | async)?.restaurant_data?.email && (data | async)?.restaurant_data?.email !==''">
      <a class="nav-link"><span class="icon"><i class="flaticon-envelope" ></i></span> {{(data | async)?.restaurant_data?.email}}</a>
    </li>
    <li class="nav-item" *ngIf="(data | async)?.restaurant_data?.domain !==''">
      <a class="nav-link" href="{{(data | async)?.restaurant_data?.domain}}">
        <span class="icon"><i class="flaticon-worldwide-1" ></i></span> {{(data | async)?.restaurant_data?.domain}}
      </a>
    </li>
  </ul> -->
  <!-- <p class="social-btns d-block d-lg-none mt-3">
    <a *ngFor="let item of (data | async)?.restaurant_data?.social_media" href="{{item?.link}}" target="_blank" class="btn {{item.media_name}}">
      <span class="ico"><i class="flaticon-{{item.media_name}}" ></i></span>
    </a>
  </p> -->
</div>
<div *ngIf="toggleActive" class="overlay"></div>

